import { useEffect, useState } from 'react';

type ExecuteGrecaptcha = () => Promise<string>;

const GCAPTCHA_KEY = import.meta.env.VITE_GCAPTCHA_KEY;

const useGrecaptcha = (): ExecuteGrecaptcha => {
  const [scriptLoaded, setScriptLoaded] = useState<boolean>(false);
  const GCAPTCHA_SCRIPT_URL = `https://recaptcha.net/recaptcha/enterprise.js?render=${GCAPTCHA_KEY}`;
  const GCAPTCHA_ACTION = 'input_email';

  useEffect(() => {
    if (!document.querySelector(`script[src="${GCAPTCHA_SCRIPT_URL}"]`)) {
      const script = document.createElement('script');
      script.src = GCAPTCHA_SCRIPT_URL;
      script.async = true;
      script.onload = () => setScriptLoaded(true);
      document.body.appendChild(script);
    } else {
      setScriptLoaded(true);
    }
  }, [GCAPTCHA_SCRIPT_URL]);

  const execute: ExecuteGrecaptcha = async () => {
    if (!scriptLoaded || !window.grecaptcha) {
      throw new Error('reCAPTCHA script not loaded');
    }

    return new Promise<string>((resolve, reject) => {
      window.grecaptcha!.enterprise.ready(async () => {
        try {
          const token = await window.grecaptcha!.enterprise.execute(GCAPTCHA_KEY, { action: GCAPTCHA_ACTION });
          resolve(token);} catch (error) {
          reject(error);
        }
      });
    });
  };

  return execute;
};

export default useGrecaptcha;
